import { Button } from "@/components/ui/button";
import { CalendarIcon, Clock } from "lucide-react";
import { format } from "date-fns";
import { ReminderDialog } from "../ReminderDialog";
import { useState } from "react";

interface SchedulingBarProps {
  scheduledFor?: string;
  onScheduleUpdate: (date: string) => void;
}

export const SchedulingBar = ({ scheduledFor, onScheduleUpdate }: SchedulingBarProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleScheduled = () => {
    setIsDialogOpen(false);
  };

  const formattedDate = scheduledFor 
    ? format(new Date(scheduledFor), "PPP 'at' p")
    : "Not scheduled";

  return (
    <div className="flex items-center justify-between p-2 bg-muted/30 rounded-lg mb-4">
      <div className="flex items-center gap-2">
        <CalendarIcon className="h-4 w-4 text-muted-foreground" />
        <span className="text-sm text-muted-foreground">Post scheduled for:</span>
        <span className="text-sm font-medium">
          {formattedDate}
        </span>
      </div>
      <Button 
        variant="outline" 
        size="sm"
        className="gap-2"
        onClick={() => setIsDialogOpen(true)}
      >
        <Clock className="h-4 w-4" />
        Reschedule
      </Button>

      <ReminderDialog
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        content=""
        onScheduled={handleScheduled}
        initialScheduledFor={scheduledFor}
        onDateSelected={(date) => {
          if (date) {
            onScheduleUpdate(date.toISOString());
          }
        }}
      />
    </div>
  );
};